import type {FC, PropsWithChildren} from 'react';
import {memo} from 'react';

interface Props {
  className?: string;
  colorClass?: string;
  containerClass?: string;
}

const ColorWrapper: FC<PropsWithChildren<Props>> = ({
  children,
  className = '',
  colorClass = '',
  containerClass = '',
}) => {
  return (
    <div className={`ColorWrapper ${className}`}>
      <div className={`colorContainer ${colorClass}`}>
        <div className={`container ${containerClass}`}>{children}</div>
      </div>
    </div>
  );
};

export default memo(ColorWrapper);
